import { throwError as observableThrowError, Observable, throwError } from "rxjs";
import { HttpClientService } from "./httpclient";
import { Injectable } from "@angular/core";
import { PlanningBlock } from "../../pb-screen/models/planning-block/planning-block.interface";
import { catchError, map } from "rxjs/operators";
import { TransportOrder } from "../../pb-screen/models/transport-order/transport-order.interface";
import { PRE_PLANNED, PLANNED, TO_BE_PLANNED } from "../../pb-screen/models/status-type.interface";
import { ToScreenService } from "../../pb-screen/services/to-screen.service";
import { environment } from "../../../environments/environment";
import { PbActions } from "../../pb-screen/pb.actions";
import { ToActions } from "../../to-screen/to.actions";
import { SharedActions } from "../shared.actions";
import { PlanningBoardActions } from "../../planningBoard/planningBoard.action";
import { select } from "@angular-redux/store";
import { ApplicationUser } from "../../pb-screen/models/application.user.interface";
import { MsalService } from "../../msal";
import { UserFeedbackService } from "../../services/user-feedback.service";
import { RE_USED } from "../models/status-type.interface";


@Injectable()
export class OrderlineService {
  @select("applicationUser") applicationUser$: Observable<ApplicationUser>;
  public user: ApplicationUser = null;

  constructor(
    private readonly http: HttpClientService,
    private readonly toService: ToScreenService,
    private readonly userFeedbackService: UserFeedbackService,
    private readonly pbActions: PbActions,
    private readonly toActions: ToActions,
    private readonly authService: MsalService,
    private readonly sharedActions: SharedActions,
    public readonly planningBoardActions: PlanningBoardActions
  ) {
  }

  /** @deprecated planning actions moved to planningaction service */
  public cancelPb(planningBlocks: PlanningBlock[]): Observable<PlanningBlock[]> {
    return this.changePbStatus(planningBlocks, { "statusType": PRE_PLANNED })
      .pipe(map((data) => {
        let updatedPbs = data;
        this.pbActions.updatePlanningBlocksDisplay(updatedPbs , true);

        this.userFeedbackService.showSuccessMessage("SHARED.PLANNING_BLOCK_SUCCESSFULLY_CANCELED");
        return data;
      }), catchError(error => {
        return throwError(error);
      }));
  }

  /** @deprecated planning actions moved to planningaction service */
  public cancelTo(transportOrder: TransportOrder): Observable<any> {
    return this.changeToStatus(transportOrder.id, "PREPLANNED", "cancel").pipe(map((data) => {
        this.pbActions.updatePlanningBlocksDisplay([...data] , true);

      this.toService.getTransportOrderById(transportOrder.id, true).subscribe((data) => {
          this.toActions.updateTransportOrdersDisplay([data]);
        });

        this.toService.getTransportOrderDetails(transportOrder.id).subscribe((data) => {
          this.sharedActions.getOrderlines(data);
        });
        this.toActions.setSelectedTransportOrders([]);

        this.userFeedbackService.showSuccessMessage("SHARED.TRANSPORT_ORDER_SUCCESSFULLY_CANCELED");
        return data;
      }),
      catchError(error => {
        return throwError(error);
      }));
  }

  /** @deprecated planning actions moved to planningaction service */
  public sendPb(planningBlocks): Observable<any> {
    let updatedPbs = [];
    return this.changePbStatus(planningBlocks, { "statusType": PLANNED }).pipe(
      map((data) => {
        updatedPbs = data;
        this.pbActions.updatePlanningBlocksDisplay(updatedPbs, true);
        this.userFeedbackService.showSuccessMessage("SHARED.PLANNING_BLOCK_SUCCESSFULLY_SENT", undefined, "SHARED.PLANNING_BLOCK_SUCCESSFULLY_SENT_TITLE");
        return data;
      }),
      catchError(err => {
        return throwError(err);
      })
    );
  }

  /** @deprecated planning actions moved to planningaction service */
  public unplanTo(planningBlocks, transportOrder): Observable<any> {
    return this.changePbStatus(planningBlocks, { "statusType": TO_BE_PLANNED })
      .switchMap((data) => {
        this.pbActions.updatePlanningBlocksDisplay([...data], true);
        return this.deleteTo(transportOrder, "").pipe(map((result) => {
          // this.toService.getTransportOrders().subscribe((data) => {
          //   this.toActions.getTransportOrders(data);
          // });
          this.userFeedbackService.showSuccessMessage("SHARED.TRANSPORT_ORDER_SUCCESSFULLY_UNPLANNED");
          this.planningBoardActions.removeTosFromCapacity([{
            tranportOrderNo: transportOrder.id,
            truckName: transportOrder.truck.name,
            driverName: transportOrder.driver
          }]);
          this.toActions.setSelectedTransportOrders([]);
          this.planningBoardActions.setSelectionType("");
          return data;
        }));
      });
  }

  changePbStatus(planningBlocks: PlanningBlock[], newStatus): Observable<any> {
    const account = this.authService.getAccount();
    let planningBlocksDelta = [];
    planningBlocks.forEach((element) => {
      planningBlocksDelta.push({ Id: element.id, Status: newStatus, TransportOrderNumber: element.transportOrderNumber });
    });
    return this.http.patch(environment.tmsApiEndpointAddress + "planningblocks", {
      PlanningBlocks: planningBlocksDelta,
      userName: account.username
    }).pipe(
      map((res: any) => {
        return res.data;
      }),
      catchError((err) => {
        return observableThrowError(err);
      })
    );
  }

  changeToStatus(toId, newStatus, params) {
    params = params || "";
    const account = this.authService.getAccount();

    return this.http.patch(environment.tmsApiEndpointAddress + "planningblocks/update-for-to/" + toId + "/" + params, {
      "Status": newStatus, "UserName": account.username
    }).pipe(
      map((res: any) => {
        return res.data;
      }),
      catchError((error) => {
        return observableThrowError(error);
      })
    );
  }

  /** @deprecated planning actions moved to planningaction service */
  public sendNextPb(transportOrder: TransportOrder) {
    let originalTo = {
      planningBlocks: [],
      orderlines: []
    };

    return this.changeToStatus(transportOrder.id, { "statusType": PLANNED }, "nextPb")
      .pipe(map((data) => {
        originalTo.planningBlocks = data;
        if (originalTo.planningBlocks.length >= 1) {
          this.pbActions.updatePlanningBlocksDisplay(originalTo.planningBlocks, true);
        }

        this.toService.getTransportOrderDetails(transportOrder.id).subscribe((data) => {
          this.sharedActions.getOrderlines(data);
        });

        this.userFeedbackService.showSuccessMessage("SHARED.NEXT_PLANNING_BLOCK_SUCCESSFULLY_SENT");
        return data;
      }));
  }

  /** @deprecated planning actions moved to planningaction service */
  public resendTo(transportOrderId): Observable<TransportOrder[]> {
    const account = this.authService.getAccount();
    return this.http.get(environment.tmsApiEndpointAddress + "transportorders/ResendID?transportorderid=" + transportOrderId
      + "&userName=" + account.username)
      .pipe(
        map((res: any) => res.data),
        catchError((err: any) => observableThrowError(err))
      );
  }

  /** @deprecated planning actions moved to planningaction service */
  deleteTo(transportOrder, capacityId) {
    return this.http.delete(environment.tmsApiEndpointAddress + "transportorders/id?toId=" + transportOrder.id + "&capacityId=" + capacityId)
      .pipe((
          map((res: any) => {
            return res.data;
          })
        ),
        catchError((error) => {
          return observableThrowError(error);
        })
      );
  }

  updateOrderline(planningBlockId, orderlineId, orderline, ignoreValidation, confirmDatePopup = false) {
    const url = `${environment.tmsApiEndpointAddress}planningBlocks/${planningBlockId}/orderlines/${orderlineId}/${ignoreValidation}?confirmDatePopup=${confirmDatePopup}`;

    return this.http.put(url, orderline).pipe(
      map((res: any) => {
        return res.data;
      })
      , catchError((err: any) => observableThrowError(err))
    );
  }

  updateOrderlineV2(orderlines: any[], ignoreValidation: boolean) {
    return this.http.put(environment.tmsApiEndpointAddress + "planningblocks/orderlines/patchupdate/" + ignoreValidation, orderlines).pipe(
      map((res: any) => {
        return res.data;
      }),
      catchError((err: any) => observableThrowError(err))
    );
  }

  public updateOrderlineReferences(params: any) {
    return this.http.post(environment.tmsApiEndpointAddress + "transportorders/update-orderline-references?orderNumber", params)
      .pipe(
        map((res: any) => res.data),
        catchError((err: any) => observableThrowError(err))
      );
  }

  public deleteOrderline(orderlineId: number) {
    return this.http.delete(environment.tmsApiEndpointAddress + "transportorders/delete-orderline?orderlineId=" + orderlineId)
      .pipe(
        map((res: any) => res.data),
        catchError((err: any) => observableThrowError(err))
      );
  }

  public addEquipmentToETAEquipment(params: any) {
    return this.http.post(environment.tmsApiEndpointAddress + "transportorders/add-equipment-to-eta", params)
      .pipe(
        map((res: any) => res.data),
        catchError((err: any) => observableThrowError(err))
      );
  }

  public groupSelectedLines(transportOrder, transportOrderId, lineOrderIds): Observable<any> {
    return this.http.put(environment.tmsApiEndpointAddress + "transportOrders/GroupSelectedLines?orderLineIds=" + lineOrderIds + "&transportOrderId=" + transportOrderId
      , transportOrder).pipe(
      map((res: any) => res.data),
      catchError((err: any) => observableThrowError(err))
    );
  }

  public unGroupSelectedLines(transportOrder, transportOrderId, lineOrderIds): Observable<any> {
    return this.http.put(environment.tmsApiEndpointAddress + "transportOrders/UngroupSelectedLines?orderLineIds=" + lineOrderIds + "&transportOrderId=" + transportOrderId
      , transportOrder).pipe(
      map((res: any) => res.data),
      catchError((err: any) => observableThrowError(err))
    );
  }

  public async setChassis(planningBlockId: number, chassisId: string): Promise<PlanningBlock> {
    const url = `${environment.tmsApiEndpointAddress}planningBlocks/${planningBlockId}/chassis`;

    return await this.http.put(url, { id: chassisId}).pipe(map((res: any) => res.data)).toPromise();
  }
}
